<template lang="pug">
  .wrap-aspect.ratio-3-1(v-if="contents.length")
    .wrapped-aspect
      v-carousel.carousel-100(hide-delimiters :hide-controls="contents.length <= 1" height="100%")
        v-carousel-item(v-for="content in contents" :key="content.title")
          .slide(:style="{ 'background-image': `url(${content.image})` }")
          .title-wrapper: .title.primary.white--text {{content.title}}

</template>

<style lang="stylus" scoped>
.slide
  background-size cover
  background-position center
  height 100%
.title-wrapper
  position absolute
  width 100%
  bottom 0
.title
  padding 1em
  opacity 0.8
.carousel-100 >>> .v-window-item
  height 100%

</style>


<script>
export default {
  props: ['extra'],
  computed: {
    visible() {
      return this.dev && this.extra.name !== 'Menu'
    },
    dev() {
      return !/\./.test(window.location.host)
    },
    contents() {
      return this.extra && this.extra.content && JSON.parse(this.extra.content) || []
    }
  }
}
</script>
